<template>
  <div class="row tools mb-0">
    <div class="col-md-2">
      <RouterButton :path="btnPath" :name="btnName" :color="btnColor"/>
    </div>
    <div class="col-md-7"></div>
    <div v-if="isSearch" class="col-md-3">
      <form @submit.prevent="submit">
        <input v-model="str" type="search" class="form-control" placeholder="Search...">
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import RouterButton from '@/components/button/RouterButton'

  export default {
    name: 'PageToolbar',
    components: {
      RouterButton
    },
    props: {
      btnPath: {
        type: String
      },
      btnName: {
        type: String,
        default: ''
      },
      btnColor: {
        type: String,
        default: 'default'
      },
      isSearch: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        models: 'apiGroup/getData'
      })
    },
    data() {
      return {
        str: '',
        selected: [],
        options: []
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      submit() {
        this.$emit('submit', this.str)
      },
      fetchData() {
        this.$store.dispatch('apiGroup/listAll', { limit: 100 })
      }
    },
    watch: {
      models(v) {
        this.options = v.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    }
  }
</script>

<style scoped>

</style>
